<template>
    <v-col class="pb-0">
        <v-card>
            <v-data-table
                :headers="richDataTableController.getVisibleHeaders()"
                :items="frontOrderBy(summary_childs)"
                :items-per-page="-1"
                class="medium-dense-table"
                style="background-color: transparent;"
                hide-default-header
                item-key="group_id"
                fixed-header
                :expanded.sync="expanded_sync"
                hide-default-footer
            >
                <template v-slot:header="{ props, on }">
                    <thead class="v-data-table-header">
                        <tr>
                            <th
                                v-for="(header, index) in richDataTableController.getVisibleHeaders()"
                                :key="index"
                                :class="[
                                    formatTableHeaderClass(header, props['options']),
                                    header['value'] === 'data-table-select' && monitoring_mode ? 'pa-0' : ''
                                ]"
                                :width="header.width"
                                role="columnheader"
                                scope="col"
                                :style="header['style']"
                                v-on="on"
                                @click="
                                    header.sortable !== false && header['value'] !== 'data-table-select'
                                        ? $emit('sortBy', header.value)
                                        : ''
                                "
                            >
                                <v-row
                                    no-gutters
                                    align="center"
                                    style="flex-wrap: nowrap; border-bottom: 2px red !important;"
                                    :justify="header['justify']"
                                >
                                    <template v-if="header.value === 'avatar'">
                                        <v-btn
                                            icon
                                            color="neutral_n300"
                                            @click="toggleGroupSelect"
                                        >
                                            <v-icon>
                                                {{
                                                    expanded_sync.length === summary_childs.length
                                                        ? "mdi-minus-box"
                                                        : "mdi-plus-box"
                                                }}
                                            </v-icon>
                                        </v-btn>
                                        <DropMenu
                                            :value="normalizedGrouping"
                                            :items="summary_groupings"
                                            :menu-props="{
                                                'open-on-hover': false,
                                                'offset-y': true
                                            }"
                                            :toggle-select="false"
                                            :multi="false"
                                            name-key="title"
                                            value-key="value"
                                            :show-selected-first="false"
                                            @input="onGroupingInput"
                                        >
                                            <template v-slot="{ on: show }">
                                                <v-btn
                                                    class="pl-2"
                                                    text
                                                    color="neutral_n300"
                                                    v-on="show"
                                                >
                                                    <span
                                                        class="text-none mr-1"
                                                        style="letter-spacing: 0.1px"
                                                    >
                                                        {{ $t("Grouped") }}:
                                                    </span>
                                                    <span
                                                        style="letter-spacing: 0.1px"
                                                        class="text-none font-weight-regular"
                                                    >
                                                        {{ normalizedGrouping[0].title }}
                                                    </span>
                                                    <v-icon
                                                        color="grey"
                                                        right
                                                    >
                                                        mdi-menu-down
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                        </DropMenu>
                                    </template>
                                    <template v-else>
                                        <div
                                            class="body-2 neutral_n400--text font-weight-medium"
                                            style="min-width:78px;"
                                        >
                                            {{ header.text }}
                                        </div>
                                        <v-icon v-if="header.value === sortBy">
                                            {{ sortDesc ? "mdi-menu-down" : "mdi-menu-up" }}
                                        </v-icon>
                                    </template>
                                </v-row>
                            </th>
                        </tr>
                    </thead>
                </template>
                <!--                <template v-slot:item="{ item, expand, isExpanded }">-->
                <template v-slot:body="{ items, expand, isExpanded }">
                    <tbody>
                        <template v-for="item in items">
                            <ReportSummaryRow
                                :key="item.group_id"
                                :headers="richDataTableController.getVisibleHeaders()"
                                :item="item"
                                :expand="expand"
                                :is-expanded="isExpanded(item)"
                                :grouping="grouping"
                                :primary-value="percentageFromMax(item)"
                                :secondary-value="extraPercentage(item)"
                                :url-adapter="urlAdapter"
                            />
                            <template v-if="isExpanded(item)">
                                <ReportSummaryChildRow
                                    v-for="subchild in item.childs"
                                    :key="subchild.sub_group_id + '_' + item.group_id"
                                    :headers="richDataTableController.getVisibleHeaders()"
                                    :item="subchild"
                                    :grouping="grouping"
                                    :primary-value="percentageFromSubChildrenMax(subchild, item.childs)"
                                    :secondary-value="extraPercentage(subchild)"
                                    :parent-id="item.group_id"
                                    :url-adapter="urlAdapter"
                                />
                            </template>
                        </template>
                    </tbody>
                </template>
            </v-data-table>
        </v-card>
    </v-col>
</template>

<script>
import ReportSummaryRow from "./ReportSummaryRow";
import ReportSummaryChildRow from "./ReportSummaryChildRow";
import ReportModule, {state} from "../../store/modules/report";
import DropMenu from "../../components/NewFilterBar/components/DropMenu";
import { format_time_from_seconds } from "../../helpers/formatting";
import { $t } from "../../i18n";
import {ref, computed, watch, onMounted, onUnmounted} from "@vue/composition-api";
import RichDataTableController from "@/components/RichDataTable/RichDataTableController";
import RichDataTable from "@/components/RichDataTable/RichDataTable";
import AccountModule from "@/store/modules/account";

export default {
    name: "ReportSummary",
    components: {
        RichDataTable,
        DropMenu,
        ReportSummaryRow,
        ReportSummaryChildRow
    },
    props: {
        grouping: {
            type: String,
            required: true,
            default: "client/topic",
        },
        groupToggleReset: {
            type: Number,
            default: 0
        },
        sortBy: {
            type: String,
            default: ""
        },
        sortDesc: {
            type: Boolean,
            default: false
        },
        urlAdapter: {
            type: Object,
            default: () => ({}),
        },
        summary_childs: {
            type: Array,
            default: () => []
        },
        richDataTableController: {
            type: RichDataTableController,
            required: true
        }
    },
    setup(props, ctx) {
        const expanded_sync = ref([]);
        const externalGroupReset = computed(() => {
            return props.groupToggleReset;
        });
        watch (externalGroupReset, val => {
            if (val && props.richDataTableController.getRows()) {
                const new_group_state = {};
                for (let i in props.richDataTableController.getRows()) {
                    new_group_state[i] = false;
                }
                group_state_toggle.value = Object.assign({}, group_state_toggle.value, new_group_state);
            }
        }, { immediate: true });
        const group_state_toggle = ref({});
        const selected_grouping = ref([{ title: $t("Client/topic"), value: "client;topic" }]);

        const all_groups_selected = computed(() => {
            const group_state_as_array = Object.values(group_state_toggle.value);
            return (
                group_state_as_array.length === props.richDataTableController.getRows().length && group_state_as_array.every(val => !!val)
            );
        });
        watch (all_groups_selected, val => ctx.emit("export_details", val), { immediate: true });
        const toggleGroupSelect = () => {
            ctx.emit("export_details", 1);
            if (expanded_sync.value.length === props.richDataTableController.getRows().length) {
                expanded_sync.value = [];
            } else {
                expanded_sync.value = [...props.richDataTableController.getRows()];
            }
        };
        const percentageFromMax = child => {
            if (child.total + child.extra === 0) return 0;
            const summaryChildsMax = props.richDataTableController.getRows() ? Math.max(...props.richDataTableController.getRows().map(c => c.total + c.extra), 0) : 0;

            return ((child.total + child.extra) / summaryChildsMax) * 100;
        };
        const percentageFromSubChildrenMax = (child, childs) => {
            const max = Math.max(...childs.map(c => c.total + c.extra), 0);
            if (child.total + child.extra === 0) return 0;
            return ((child.total + child.extra) / max) * 100;
        };
        const extraPercentage = child => {
            return (child.extra / child.total) * 100;
        };

        const { isFeatureEnabledAnywhere } = AccountModule();
        const projectEnabled = isFeatureEnabledAnywhere("project");
        const summary_groupings = [
            { title: $t("Client/topic"), value: "client;topic" },
            { title: $t("Client/task"), value: "client;title" },
            { title: $t("Client/member"), value: "client;assignee" },
            { title: $t("Member/topic"), value: "assignee;topic" },
            { title: $t("Member/task"), value: "assignee;title" },
            { title: $t("Member/client"), value: "assignee;client" },
            { title: $t("Member/date"), value: "assignee;date" },
            { title: $t("Date/member"), value: "date;assignee" }
        ];
        if(projectEnabled) {
            summary_groupings.splice(3, 0 ,{ title: $t("Client/project"), value: "client;project" })
            summary_groupings.push({ title: $t("Project/member"), value: "project;assignee" })
        }
        const normalizedGrouping = computed(() => {
            return [{ ...summary_groupings.find(g => g.value === props.grouping) }];
        });
        const onGroupingInput = ev => {
            ctx.emit("update:grouping", ev[0].value);
        };

        const formatTableHeaderClass = (header, options) => {
            let classes = [];
            if (header.align) {
                classes.push("text-" + header.align);
            }
            if (header.sortable !== false && header["value"] !== "data-table-select") {
                classes.push("sortable");
            }
            if (header.value === options.sortBy) {
                classes.push("active");
                classes.push(options.sortDesc ? "desc" : "asc");
            }
            return classes.join(" ");
        };
        const frontOrderBy = items => {
            let groupingArr = props.grouping.split(";");
            let compare = (function () {
                if (groupingArr[0] === "client" && props.sortBy === '') {
                    return (a, b) => {
                        // workaround to inconsistent data loading
                        if(!a.client || !b.client) return 0;
                        if (a.client.name < b.client.name) return props.sortDesc ? 1 : -1;
                        if (a.client.name > b.client.name) return props.sortDesc ? -1 : 1;
                        return 0;
                    };
                } else {
                    return (a, b) => {
                        if (a[props.sortBy] > b[props.sortBy]) return props.sortDesc ? 1 : -1;
                        if (a[props.sortBy] < b[props.sortBy]) return props.sortDesc ? -1 : 1;
                        return 0;
                    };
                }
            })();
            return [...items].sort(compare);
        };

        const resizeTable = async () => {
            if (!ctx.parent.$el) {
                return
            }

            if (!ctx.parent.$el.querySelector) {
                return
            }

            const dataTable = ctx.parent.$el.querySelector('.v-data-table')
            if (!dataTable) {
                return
            }

            const dataTableWrapper = dataTable.querySelector('.v-data-table__wrapper')
            if (!dataTableWrapper) {
                return
            }

            let height = window.innerHeight - dataTable.getBoundingClientRect().top - 12

            dataTableWrapper.style.maxHeight = height + 'px'
        }

        watch (() => props.richDataTableController.isLoading(), () => {
            resizeTable()
        }, { immediate: true })

        onMounted(() => {
            resizeTable()
            window.addEventListener('resize', resizeTable)
        })

        onUnmounted(() => {
            window.removeEventListener('resize', resizeTable)
        })

        return {
            onGroupingInput,
            normalizedGrouping,
            group_state_toggle,
            selected_grouping,
            summary_groupings,
            all_groups_selected,
            toggleGroupSelect,
            format_time_from_seconds,
            percentageFromMax,
            extraPercentage,
            formatTableHeaderClass,
            expanded_sync,
            frontOrderBy,
            percentageFromSubChildrenMax,
        };
    }
};
</script>

<style scoped lang="scss">
.v-data-table ::v-deep .v-data-table__wrapper {
    border-radius: 8px;
}
</style>